/**
 * Bundlex + Empire AddToCartFlyout fix
 *
 * Problem: Bundlex multi-item /cart/add.js responses return { items: [...] }
 * without top-level variant_options. Empire's AddToCartFlyout then throws on
 * response.variant_options[0], so the ATC button stays in "processing".
 *
 * Install:
 * 1. Online Store → Themes → Edit code → Assets → Add a new asset
 *    Upload this file as: bundlex-atc-flyout-fix.js
 * 2. In layout/theme.liquid, before </body>, add:
 *    <script src="{{ 'bundlex-atc-flyout-fix.js' | asset_url }}" defer></script>
 *    (Must load after theme.js)
 */
(function () {
  'use strict';

  var MAX_ATTEMPTS = 80;
  var ATTEMPT_MS = 50;

  function normalizeCartAddResponse(response) {
    if (!response || typeof response !== 'object') return response;

    // Multi-item add (bundle apps): { items: [lineItem, ...] }
    if (!response.id && Array.isArray(response.items) && response.items.length) {
      response = response.items[0];
    }

    if (response && response.variant_options == null) {
      response.variant_options = [];
    }

    return response;
  }

  function isCartAddUrl(url) {
    return typeof url === 'string' && /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
  }

  function patch(AddToCartFlyout, $) {
    if (AddToCartFlyout.__bundlexAtcPatched) return;
    AddToCartFlyout.__bundlexAtcPatched = true;

    var proto = AddToCartFlyout.prototype;
    var originalUpdateCart = proto._updateCart;

    proto._updateCart = function patchedUpdateCart() {
      var self = this;
      var originalAjax = $.ajax;

      // Ensure quantity exists so quantityField[0] is safe
      if (Array.isArray(this.formData)) {
        var hasQuantity = this.formData.some(function (field) {
          return field && field.name === 'quantity';
        });
        if (!hasQuantity) {
          this.formData = this.formData.concat([{ name: 'quantity', value: '1' }]);
        }
      }

      $.ajax = function (url, options) {
        // Support $.ajax(url, opts) and $.ajax(opts)
        var opts;
        if (typeof url === 'object') {
          opts = url;
        } else {
          opts = options || {};
          opts.url = url;
        }

        var jqXHR = originalAjax.call(this, opts);

        if (!isCartAddUrl(opts.url || '')) {
          return jqXHR;
        }

        var originalDone = jqXHR.done;
        jqXHR.done = function (callback) {
          if (typeof callback !== 'function') {
            return originalDone.apply(this, arguments);
          }

          return originalDone.call(jqXHR, function (response) {
            var normalized = response;
            try {
              normalized = normalizeCartAddResponse(response);
            } catch (err) {
              console.error('[bundlex-atc-flyout-fix] Failed to normalize cart/add response', err);
              if (self._enableAtcButton) self._enableAtcButton();
              return;
            }

            try {
              return callback.call(this, normalized);
            } catch (err) {
              console.error('[bundlex-atc-flyout-fix] AddToCartFlyout handler error', err);
              if (self._enableAtcButton) self._enableAtcButton();
            }
          });
        };

        return jqXHR;
      };

      try {
        return originalUpdateCart.apply(this, arguments);
      } catch (err) {
        console.error('[bundlex-atc-flyout-fix] _updateCart error', err);
        if (self._enableAtcButton) self._enableAtcButton();
      } finally {
        // First cart/add $.ajax is sync to start; its .done runs later.
        // Restoring here is correct — only the add call needs wrapping.
        $.ajax = originalAjax;
      }
    };

    console.info('[bundlex-atc-flyout-fix] AddToCartFlyout patch applied');
  }

  function tryPatch(attempt) {
    var AddToCartFlyout = window.AddToCartFlyout;
    var $ = window.jQuery || window.$;

    if (AddToCartFlyout && $ && $.ajax) {
      patch(AddToCartFlyout, $);
      return;
    }

    if (attempt >= MAX_ATTEMPTS) {
      console.warn('[bundlex-atc-flyout-fix] AddToCartFlyout/jQuery not found; patch not applied');
      return;
    }

    setTimeout(function () {
      tryPatch(attempt + 1);
    }, ATTEMPT_MS);
  }

  tryPatch(0);
})();
